import { mapGetters } from "vuex";
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper"
import diff from "deep-diff";
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import cloneDeep from 'lodash/cloneDeep';
import { openDatabase } from '@/pages/Projects/Utils/IndexedDB.js';
import Rules from "@/utils/Rules";

import UtilsProjects from "@/pages/Projects/Utils/Utils.js";

import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import DiagnosticServiceFirebase from "@/services/firebase/Diagnostic/DiagnosticService";

import NextStepProject from "@/components/Projects/NextStepProject.vue"
import DiagnosticStepper from "@/components/Projects/Diagnostic/DiagnosticStepper.vue"

import CheckListTab from "@/components/ProjectsKits/Diagnostic/Tabs/CheckList/CheckList.vue"
import HistoricTab from "@/components/ProjectsKits/Diagnostic/Tabs/Historic/Historic.vue"
import ProposalTab from "@/components/ProjectsKits/Proposal/Proposal.vue"
import HistoricService from "@/services/firebase/Historic/HistoricService";
import AverageNextStep from "@/components/AverageNextStep/AverageNextStep.vue"

export default {
    name: "Diagnóstico",

    components: {
        NextStepProject,
        DiagnosticStepper,
        CheckListTab,
        HistoricTab,
        ProposalTab,
        AverageNextStep
    },
    props: {
        openModal: {
            type: Boolean,
            default: false
        },
        idLead: {
            type: String,
            default: null
        },
        idDiagnostic: {
            type: String,
            default: null,
            validator: (v) => v === null || typeof v === 'string'
        },
        closeFunc: {
            type: Function,
            default: () => { }
        },
        currentStep: {
            type: String,
            default: null,
        },
        initialTab: {
            type: String,
            default: 'checklist', // 'checklist', 'historic', 'proposal'
        },
        proposalType: {
            type: String,
            default: null // Tipo de proposta para filtrar soluções (ex: 'kit_sell')
        }
    },
    data: () => ({
        model: null,
        desiredProposal: [],
        filterRequiredFields: [],
        buttonMessage: "Solicitar Propostas",
        db: null,
        isValidForm: false,
        loadingDialog: true,
        savedImages: [],
        is_loading: false,
        is_created: false,
        dialogAlert: false,
        dialog: false,
        dialogConfirmDeleteLocal: false,
        id_project: null,
        id_diagnostic: null,
        proposalsList: [],
        is_completed: true,
        oldDiagnostic: {},
        // Propriedades para o modal de carregamento da estrutura de dados
        isUpdatingDataStructure: false,
        updatingDataStructureMessage: "A estrutura de dados está sendo atualizada...",
        diagnostic: {
            historics: [],
            solutionList: [],
        },
        steps: [
            {
                id: 'checklist',
                name: 'CheckList',
                step: '1',
                editable: true,
                complete: false,
                rules: [() => true],
            },
            {
                id: 'historic',
                name: 'Histórico',
                step: '2',
                editable: true,
                complete: false,
                rules: [() => true],
            },
        ],
        visibleTabs: {
            checklist: true,
            historic: false,
            proposal: false,
        },
        isProposalOnlyMode: false,
        localStorageData: null,
        existDiagnosticIndexedDB: false,
        disabledButtonNextStep: false,
        readonlyScreen: true,
        requestSaveProposal: false,
        lastProposalRevisionStatus: null,
        lastProposal: null,
        enableAddEvent: false,
        project_data: null,
        loadingSaveRevision: false,
        showAverageNextStep: false,
        nextStepVariable: "waterscan",
    }),

    computed: {
        ...mapGetters([
            "getFranqueados",
            "getCurrentUser",
            "getCurrentUserRank",
            "getStatusCanDeletedDataAdmin",
            "getCurrentUserData",
        ]),
        isOline() {
            return navigator.onLine
        },
        isFranchisee() {
            return this.getCurrentUserRank === "Franqueado"
        },
        // disableSaveButton removed as revisão fluxo foi desativado
        rulesRequired() {
            return Rules.required()
        },
    },
    
    methods: {
        // saveRevision removido (funcionalidade de revisão desativada)
        async addStautsProject(id_project, status, statusAdm = null) {
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.DIAGNOSTIC, status, this.currentStep)
            await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.DIAGNOSTIC, statusAdm ? statusAdm : status, this.currentStep, false)
        },
        checkFields() {
            if (this.$refs.diagnosticForm && !this.$refs.diagnosticForm.validate()) throw new Error("Preencha todos os campos!")
            if (!this.diagnostic.solutionList?.length && this.filterRequiredFields.includes('checklist')) throw new Error("Adicione ao menos uma solução!")
            if (!this.diagnostic.hydrometerList?.length && this.filterRequiredFields.includes('hydrometer')) throw new Error("Adicione ao menos um hidrometro!")
            if (!this.diagnostic.reservoirList?.length && this.filterRequiredFields.includes('reservoir')) throw new Error("Adicione ao menos um reservatorio!")
            if (!this.diagnostic.bombList?.length && this.filterRequiredFields.includes('bomb')) throw new Error("Adicione ao menos uma bomba!")
            if (!this.diagnostic.historics?.length && this.filterRequiredFields.includes('historic')) throw new Error("Adicione ao menos 1 mes ao histórico!")
        },
        async save() {
            this.is_loading = true
            console.log(">>>>>>>> SAVE <<<<<<<<")
            console.log(">>>>>>>> Is Online <<<<<<<<", this.isOline)

            if (!this.isOline) {
                showInfoSnackBar("Você está offline no momento, as informações foram salvas localmente")
                this.close()
                return
            }

            try {
                await this.saveOrCreate()
                await this.deleteItemIndexedDB(this.idDiagnostic)
                this.is_loading = false
                this.close()
            } catch (error) {
                console.error(error)
                showErrorSnackBar("Você está offline no momento, as informações foram salvas localmente")
            }
        },
        async saveProposal(proposal) {
            this.is_loading = true
            await DiagnosticProposalService.createDiagnostic(proposal)
            this.is_loading = false
            this.close()
        },
        async processImage(id_doc, data, fileProp, pathProp) {
            try {
                if (data.hasOwnProperty(fileProp)) {
                    if (data[pathProp]) await DiagnosticStorage.deleteImg(data[pathProp])
                    data[pathProp] = null
                    if (data[fileProp]) {
                        data[pathProp] = await DiagnosticStorage.uploadImg(id_doc, data[fileProp])
                        this.savedImages.unshift({ name: `Imagem ${this.savedImages.length + 1}` })
                    }
                }
                delete data[fileProp]
            } catch (error) {
                console.error(`Error processing image for ${fileProp}:`, error);
            }
        },
        async saveImages(diagnosticId, checklist) {
            const processImage = this.processImage
            async function processChecklistItems(items, fileProp, pathProp) {
                for (const key in items) {
                    await processImage(diagnosticId, items[key], fileProp, pathProp);
                }
            }

            const checklistMappings = [
                { items: checklist.solutionList, fileProp: 'file_after_solution', pathProp: 'path_after_solution' },
                { items: checklist.solutionList, fileProp: 'file_before_solution', pathProp: 'path_before_solution' },
                { items: checklist.reservoirList, fileProp: 'file_photo', pathProp: 'path_photo' },
                { items: checklist.hydrometerList, fileProp: 'file_photo', pathProp: 'path_photo' },
                { items: checklist.bombList, fileProp: 'file_photo', pathProp: 'path_photo' }
            ];

            for (const { items, fileProp, pathProp } of checklistMappings) {
                await processChecklistItems(items, fileProp, pathProp);
            }
        },
        async saveDiagnostic(mode = "edit") {
            console.log(">>>>>>>> SAVE DIAGNOSTIC <<<<<<<<")
            console.log(">>>>>>>> MODE <<<<<<<<", mode)
            console.log(">>>>>>>> ID DIAGNOSTIC <<<<<<<<", this.idDiagnostic)
            try{
                const deleteImages = this.$refs.CheckListTab.deletedItemsWithPhoto
                async function updateProposalsStatus(proposalsList) {
                    const updateProposal = async (proposal) => {
                        const updatedProposal = {
                            ...proposal,
                            revision: { ...proposal.revision, status: "outdated" }
                        };
                        await DiagnosticProposalService.editWaterScanProposal(updatedProposal.id_doc, updatedProposal);
                    };
                    await Promise.all(proposalsList.map(updateProposal));
                }

                async function updateSolutions(solutionsList,id_diagnostic) { 
                    if (solutionsList && solutionsList.length > 0) {
                        for (const solution of solutionsList) {
                            if(solution.isDeleted === true){
                                await DiagnosticServiceFirebase.deleteDiagnosticSolution(id_diagnostic, solution.id)
                            }else{
                                await DiagnosticServiceFirebase.createDiagnosticSolution(solution, id_diagnostic);
                            }
                        }
                    }
                }

                // Fluxo standalone quando não há idDiagnostic (vinculado só a lead/franqueado)
                if (!this.idDiagnostic) {
                    const currentData = cloneDeep(this.diagnostic) || {};
                    // Garantir estrutura mínima
                    currentData.solutionList = currentData.solutionList || [];
                    const { solutionList, ...dataWithoutSolutions } = currentData;
                    // Payload com vínculos obrigatórios
                    const payload = {
                        ...dataWithoutSolutions,
                        id_lead: this.idLead || dataWithoutSolutions.id_lead || null,
                        id_franchisee: (this.getCurrentUserData && this.getCurrentUserData.id) || dataWithoutSolutions.id_franchisee || null,
                    };

                    if (mode === "edit" && this.diagnostic.id_doc) {
                        // Atualização standalone
                        await this.saveImages(this.diagnostic.id_doc, currentData)
                        await DiagnosticServiceFirebase.update({ ...payload, id_doc: this.diagnostic.id_doc, lastUpdateAt: new Date().getTime() });
                        const filteredSolutionList = (solutionList || []).filter(s => s.isModified || s.isDeleted);
                        if (filteredSolutionList.length) {
                            for (const solution of filteredSolutionList) {
                                if (solution.isDeleted === true) {
                                    await DiagnosticServiceFirebase.deleteDiagnosticSolution(this.diagnostic.id_doc, solution.id);
                                } else {
                                    await DiagnosticServiceFirebase.createDiagnosticSolution(solution, this.diagnostic.id_doc);
                                }
                            }
                        }
                        showSuccessSnackBar("Diagnóstico atualizado com sucesso!")
                        // Emitir evento para atualizar lista no componente pai
                        this.$emit('saved', { id_doc: this.diagnostic.id_doc, mode: 'edit' });
                        return;
                    }

                    // Criação standalone
                    const idReceived = await DiagnosticServiceFirebase.create(payload)
                    this.id_diagnostic = idReceived.data.data;
                    await this.saveImages(this.id_diagnostic, currentData)
                    const diagnosticReceived = { id_doc: this.id_diagnostic, ...payload }
                    // Persistir soluções
                    for (const solution of (solutionList || [])) {
                        await DiagnosticServiceFirebase.createDiagnosticSolution(solution, this.id_diagnostic);
                    }
                    await DiagnosticServiceFirebase.update(diagnosticReceived)

                    this.diagnostic = cloneDeep({ ...diagnosticReceived, solutionList: solutionList || [] })
                    this.oldDiagnostic = cloneDeep({ ...diagnosticReceived, solutionList: solutionList || [] })
                    showSuccessSnackBar("Diagnóstico criado com sucesso!")
                    // Emitir evento para atualizar lista no componente pai
                    this.$emit('saved', { id_doc: this.id_diagnostic, mode: 'create' });
                    return;
                }

                const transaction = this.db.transaction(["diagnostics"], "readwrite");
                const diagnosticsIndexed = transaction.objectStore("diagnostics");
                const response = diagnosticsIndexed.get(this.idDiagnostic)
                this.requestSaveProposal = false
    
                await new Promise((resolve, reject) => {
                    response.onsuccess = async () => {
                        let currentData = response.result;
    
                        if (!currentData) {
                            this.is_loading = false
                            return resolve()
                        }
    
                        await HistoricService.saveHistoricList(currentData.historics)
                        if (currentData?.historicsToDelete?.length) await HistoricService.deleteHistoricList(currentData.historicsToDelete);
    
                        delete currentData.historicsToDelete
                        delete currentData.historics
                        if (mode === "edit") {
                            //EDIT
                            const hasDiff = diff(currentData, this.oldDiagnostic);
                            if (hasDiff) {
                                await updateProposalsStatus(this.proposalsList)
                            }
                            for (const path of deleteImages) {
                                await DiagnosticStorage.deleteImg(path)
                            }
                            await this.saveImages(this.diagnostic.id_doc, currentData)
                            const { solutionList, ...dataWithoutSolutions } = currentData;
                            await DiagnosticServiceFirebase.update({...dataWithoutSolutions,id_doc: this.diagnostic.id_doc, lastUpdateAt: new Date().getTime()});
                            const filteredSolutionList = solutionList.filter(solution => solution.isModified || solution.isDeleted)
                            await updateSolutions(filteredSolutionList, this.diagnostic.id_doc)

                            // Logs e status de projeto removidos (uso apenas de idDiagnostic)
    
                            showSuccessSnackBar("Rascunho salvo com sucesso")
                            // Emitir evento para atualizar lista no componente pai
                            this.$emit('saved', { id_doc: this.diagnostic.id_doc, mode: 'edit' });
                            resolve()
                        } else {
                            console.log(">>>>>>>> CREATE <<<<<<<<")
                            //CREATE
                            // Verificação por projeto removida; operação baseada apenas em idDiagnostic
                            // TODO: Corrigir o primeiro create pois está criando com estrutura antiga e não está salvando as soluções em sub coleção
                            
                            const { solutionList, ...dataWithoutSolutions } = currentData;
                            // Incluir id_lead e id_franchisee na criação do diagnóstico
                            const payload = {
                                ...dataWithoutSolutions,
                                id_lead: this.idLead || dataWithoutSolutions.id_lead || null,
                                id_franchisee: (this.getCurrentUserData && this.getCurrentUserData.id) || dataWithoutSolutions.id_franchisee || null,
                            };
                            const idReceived = await DiagnosticServiceFirebase.create(payload)

                            this.id_diagnostic = idReceived.data.data;
                            await this.saveImages(this.id_diagnostic, currentData)
                            const diagnosticReceived = { id_doc: this.id_diagnostic, ...payload }
                            await updateSolutions(solutionList, this.id_diagnostic)

                            delete diagnosticReceived.historics;
                            delete diagnosticReceived.historicsToDelete;
                            await DiagnosticServiceFirebase.update(diagnosticReceived)
                            
                            this.diagnostic = cloneDeep({...diagnosticReceived,solutionList: solutionList || []})
                            this.oldDiagnostic = cloneDeep({...diagnosticReceived,solutionList: solutionList || []})
                            // Logs e status de projeto removidos (uso apenas de idDiagnostic)
                            showSuccessSnackBar("Rascunho Criado!")
                            // Emitir evento para atualizar lista no componente pai
                            this.$emit('saved', { id_doc: this.id_diagnostic, mode: 'create' });
                            resolve()
                        }
                    }
                })
            }catch (error) {
                console.error(error);
                showErrorSnackBar(error.message);
                this.is_loading = false;
                return
            }
        },
        async saveOrCreate() {
            try {
                if (this.diagnostic.id_doc) await this.saveDiagnostic()
                else await this.saveDiagnostic("create")
            } catch (error) {
                console.error(error)
                showErrorSnackBar('Erro ao Salvar')
                this.close()
                throw new Error('Erro ao Salvar')
            }

        },

        close() {
            this.closeFunc('diagnostic')
        },
        async waitForAverageNextStep() {
            return new Promise(resolve => {
              this.showAverageNextStep = true;
          
              const modal = this.$refs.averageModal;
          
              const handler = () => {
                modal.$off('closed', handler);
                resolve();
              };
          
              modal.$on('closed', handler);
            });
          },
        initializeTab(tabId) {
            // Encontrar o step correspondente ao tabId
            const stepIndex = this.steps.findIndex(({ id }) => id === tabId);
            
            if (stepIndex >= 0) {
                const step = this.steps[stepIndex];
                // Ativar a tab correspondente
                Object.keys(this.visibleTabs).forEach((key) => {
                    this.visibleTabs[key] = key === tabId;
                });
            }
        },
        nextTab(tabStep) {
            if (!this.isFranchisee) {

                if (tabStep == 3) {
                    this.disabledButtonNextStep = false
                } else {
                    this.disabledButtonNextStep = true
                }
            }
            const index = this.steps.findIndex(({ step }) => step === tabStep.toString())

            if (index < 0) throw new Error(`Não foi encontrado a aba: ${tabStep}`)
            Object.keys(this.visibleTabs).forEach(
                (key) => {
                    if (key === this.steps[index].id) {
                        this.visibleTabs[key] = true
                    } else {
                        this.visibleTabs[key] = false
                    }
                }
            )

        },
        updateDiagnostic(diagnostic) {
            this.addEvent(diagnostic)
            this.diagnostic = diagnostic
        },
        validateTab(tabName, status) {
            let index = this.steps.findIndex(
                ({ id }) => {
                    return id === tabName
                }
            )
            if (index < 0) {
                throw new Error(`Não foi encontrado a aba: ${tabName}`)
            }
            this.steps[index].rules = [() => status]
        },
        async getLocalStorageDiagnostic() {
            this.diagnostic = cloneDeep(this.localStorageData)
            this.enableAddEvent = true
            this.dialogAlert = false
        },
        async cancelGetLocalStorageDiagnostic() {
            this.dialogConfirmDeleteLocal = true;
        },
        confirmDeleteLocal() {
            // Chama o método original para realmente excluir
            this.deleteItemIndexedDB(this.idDiagnostic);
            this.dialogAlert = false;
            this.dialogConfirmDeleteLocal = false;
            this.enableAddEvent = true;
        },
        cancelDeleteLocal() {
            this.dialogConfirmDeleteLocal = false;
        },
        async checkOldHistorics(){
            if (this.oldDiagnostic?.historics?.length) {
                // id de projeto removido neste contexto

                await HistoricService.saveHistoricList(this.oldDiagnostic.historics)
                await DiagnosticServiceFirebase.removeHistoricListFromDiagnostic(this.idDiagnostic)
            }
        },
        async getFirestoreDiagnostic() {
            console.log(">>>>>>>> GET FIRESTORE DIAGNOSTIC <<<<<<<<")
            if (this.idDiagnostic) {
                const diagnosticResponse = await DiagnosticServiceFirebase.getDiagnosticByDiagnosticId(this.idDiagnostic)
                console.log(">>>>>>>> DIAGNOSTIC RESPONSE <<<<<<<<", diagnosticResponse)
                this.proposalsList = await DiagnosticProposalService.getWaterScanProposalByDiagnosticId(this.idDiagnostic);
                this.oldDiagnostic = cloneDeep(diagnosticResponse)
                if(this.oldDiagnostic.solutionList){
                    // Ativa o modal de carregamento
                    this.isUpdatingDataStructure = true;
                    
                    try {
                        this.oldDiagnostic = await DiagnosticServiceFirebase.legacyDiagnosticSolution(diagnosticResponse)
                    } finally {
                        // Desativa o modal de carregamento
                        this.isUpdatingDataStructure = false;
                    }
                }else{
                    this.oldDiagnostic.solutionList = await DiagnosticServiceFirebase.getDiagnosticSolutionByDiagnosticId(this.idDiagnostic)
                }

                await this.checkOldHistorics()
                
                // Carregar histórico do HistoricService quando há idDiagnostic
                if (this.idDiagnostic) {
                    this.oldDiagnostic.historics = await HistoricService.getAllHistoricsByProjectId(this.idDiagnostic);
                    this.diagnostic = cloneDeep(this.oldDiagnostic);
                }
            } else {
                // Para propostas sem waterscan (sem idDiagnostic)
                if (!this.idDiagnostic && this.idLead) {
                    // Inicializar diagnostic vazio para proposta sem waterscan
                    this.oldDiagnostic = {
                        historics: [],
                        solutionList: [],
                    };
                    this.diagnostic = cloneDeep(this.oldDiagnostic);
                } else {
                    this.buttonMessage = "Solicitar Propostas"
                }
            }
        },
        async deleteItemIndexedDB(id) {
            if (!id) {
                console.warn("deleteItemIndexedDB: No id provided, skipping delete operation");
                return;
            }
            if (!this.db) {
                console.warn("deleteItemIndexedDB: Database not initialized, skipping delete operation");
                return;
            }
            const transaction = this.db.transaction(["diagnostics"], "readwrite");
            const diagnosticsIndexed = transaction.objectStore("diagnostics");
            await diagnosticsIndexed.delete(id);
        },
        async checkIndexedDB() {
            this.db = await openDatabase("diagnostics", 1);

            if (!this.db) {
                console.error("Database not initialized.");
                return;
            }
            if (!this.idDiagnostic) return;
            const transaction = this.db.transaction(["diagnostics"], "readwrite");
            const diagnosticsIndexed = transaction.objectStore("diagnostics");
            const response = diagnosticsIndexed.get(this.idDiagnostic)

            response.onsuccess = async () => {
                const currentData = response.result;
                this.diagnostic = cloneDeep(this.oldDiagnostic)
                if(!this.diagnostic)this.diagnostic = cloneDeep(this.oldDiagnostic)
                if (currentData) {
                    this.localStorageData = currentData
                    if (this.localStorageData.lastUpdateAt <= this.oldDiagnostic.lastUpdateAt) {
                        this.deleteItemIndexedDB(this.idDiagnostic)
                        this.enableAddEvent = true
                        return
                    }

                    // Sempre mostrar o modal se houver dados locais
                    this.dialogAlert = true;

                    this.existDiagnosticIndexedDB = true
                } else {
                    this.existDiagnosticIndexedDB = false
                    this.enableAddEvent = true
                }
            }

        },
        async addEvent(data) {
            const transaction = this.db.transaction(["diagnostics"], "readwrite");
            const diagnosticsIndexed = transaction.objectStore("diagnostics");
            await diagnosticsIndexed.put({ ...data, lastUpdateAt: new Date().getTime() });
        },

        async checkProposalTypeAndGetRequiredFields() {
            this.desiredProposal = []

            const requiredFields = {
                investment: [
                    'checklist',
                ],
                management: [
                    'hydrometer',
                ],
                pre_fixed: [
                    'checklist',
                ],
                model_performance: [
                    'checklist',
                    'historic'
                ],
            }

            this.filterRequiredFields = this.desiredProposal?.reduce((acc, proposal) => {
                const permissions = requiredFields[proposal] || [];
                return [...new Set([...acc, ...permissions])];
            }, []);

        }
    },

    async created() {
        this.is_loading = true;

        await this.getFirestoreDiagnostic()
        await this.checkIndexedDB()

        await this.checkProposalTypeAndGetRequiredFields()

        // Inicializar a tab baseado no initialTab prop
        this.initializeTab(this.initialTab);

        this.is_loading = false;
    },
};